import React, { PureComponent } from 'react';
import isFunction from 'lodash/isFunction';

const I18nContext = React.createContext();

export const i18nDictionary = {
  'en-US': {
    BLANK: '',
    'login.header': 'Welcome to M&M Client Portal',
    'login.form.emailAddress': 'Email Address',
    'login.form.password': 'Password',
    'login.form.button.login': 'Log In',
    'login.form.button.forgotPassword': 'Forgot Password?',
    'login.form.button.signUp': 'Sign Up',
    'signup.header': 'Sign Up for M&M Client Portal',
    'signup.form.emailAddress': 'Email Address',
    'signup.form.firstName': 'First Name',
    'signup.form.lastName': 'Last Name',
    'signup.form.company': 'Company',
    'signup.form.title': 'Title',
    'signup.form.phoneNumber': 'Phone Number',
    'signup.form.button.signup': 'Sign Up',
    'signup.form.button.returnToLogin': 'Return to Log In',
    'signup.form.button.checkEmail':
      'Check your email to complete registration.',
    'signup.form.button.getAssistance':
      'Contact M&M for support to continue your registration.',
    'resetPassword.form.header': 'Reset Password',
    'resetPassword.form.newPassword': 'New Password',
    'resetPassword.form.confirmPassword': 'Confirm Password',
    'resetPassword.form.button.submit': 'Submit',
    'resetPassword.form.link.returnToLogin': 'Return to Log In',
    'resetPassword.form.link.success': 'Your password has been reset.',
    'forgotPassword.form.header': 'Forgot Password',
    'forgotPassword.form.emailAddress': 'Email Address',
    'forgotPassword.form.button.submit': 'Submit',
    'forgotPassword.form.link.returnToLogin': 'Return to Log In',
    'forgotPassword.form.checkEmail':
      'Check your email to reset your password.',
    'completeRegistration.form.header': 'Complete Registration',
    'completeRegistration.form.password': 'Password',
    'completeRegistration.form.confirmPassword': 'Confirm Password',
    'completeRegistration.form.button.submit': 'Submit',
    'footer.supportLink': 'Call 1-800-551-8900 for support',
    'footer.button.reportIssue': 'Report Issue',
    'navigation.report-issue': 'Help',
    'navigation.logout': 'Log Out',
    'dashboard.favorites': 'Favorites',
    'dashboard.history': 'History',
    'dashboard.tab-title.purchase-orders': ({ count }) =>
      `Purchase Orders (${count})`,
    'dashboard.tab-title.part-numbers': ({ count }) => `Part Numbers (${count})`,
    'dashboard.tab-title.serial-numbers': ({ count }) =>
      `Serial Numbers (${count})`,
  },
  fr: {
    'navigation.report-issue': 'Report Issue',
    'navigation.logout': 'Log Out',
    'dashboard.favorites': 'Le´ Favorites',
    'dashboard.history': 'Le´ History',
    'dashboard.tab-title.purchase-orders': ({ count }) =>
      `Purchase Orders (${count})`,
    'dashboard.tab-title.part-numbers': ({ count }) => `Part Numbers (${count})`,
    'dashboard.tab-title.serial-numbers': ({ count }) =>
      `Serial Numbers (${count})`,
  },
};

export const getBrowserLanguage = (defaultLanguage = 'en-US') =>
  i18nDictionary[navigator.language] ||
  i18nDictionary[defaultLanguage] ||
  i18nDictionary['en-US'];

export function withLocale(Component) {
  return function LocaleAwareComponent(props) {
    return (
      <I18nContext.Consumer>
        {locale => <Component {...props} locale={locale} />}
      </I18nContext.Consumer>
    );
  };
}

export const FormattedMessage = withLocale(
  class extends PureComponent {
    render() {
      const { locale, id, values = {} } = this.props;
      const accessor = locale[id];
      return isFunction(accessor) ? accessor(values) : accessor;
    }
  }
);

export default I18nContext;
